/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import App from 'apmui/App';
import bind from 'apmui/decorators/bind';
import IDecisionBoxModel, { IDecisionBoxOption, FORM_ID, FIELD_NAME } from './Model';

const app = App.get();

class DecisionBoxLink extends React.Component<IDecisionBoxOption> {
    @bind
    onClick() {
        app.updateFormField(FORM_ID, FIELD_NAME, String(this.props.result));
        app.submitForm(FORM_ID);
    }

    render() {
        return (
            <p>
                <button
                    className="apmui-button-inline apmui-link apmui-u-vertical-aligned"
                    id={FIELD_NAME + this.props.result}
                    onClick={this.onClick}>
                    <img src={this.props.image} alt="" />
                    {this.props.message}
                </button>
            </p>
        );
    }
}

export default class DecisionBoxView extends React.Component<IDecisionBoxModel> {
    render() {
        const { title, options } = this.props.decisionBox.config;
        return (
            <div className="apmui-content">
                {title && <h2>{title}</h2>}
                {options.map((option) => (
                    <DecisionBoxLink key={FIELD_NAME + option.result} {...option} />
                ))}
            </div>
        );
    }
}
